import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02d17b57"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "card-global" }
const _hoisted_3 = { class: "flex items-center justify-between gap-4" }
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "mt-2 text-sm text-gray-500" }
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = { class: "field" }
const _hoisted_15 = { class: "field md:col-span-2" }
const _hoisted_16 = { class: "md:col-span-2 flex justify-end" }
const _hoisted_17 = ["onSubmit"]
const _hoisted_18 = { class: "md:col-span-2 text-lg font-semibold" }
const _hoisted_19 = { class: "field" }
const _hoisted_20 = { class: "field" }
const _hoisted_21 = { class: "field md:col-span-2" }
const _hoisted_22 = { class: "logo-editor" }
const _hoisted_23 = { class: "tenant-logo-preview" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "flex min-w-0 flex-1 flex-col gap-3" }
const _hoisted_27 = { class: "text-xs font-normal text-gray-500" }
const _hoisted_28 = { class: "flex flex-wrap gap-3" }
const _hoisted_29 = { class: "md:col-span-2 flex justify-end gap-3" }
const _hoisted_30 = { class: "card-global" }
const _hoisted_31 = {
  key: 0,
  class: "py-8 text-center text-gray-500"
}
const _hoisted_32 = ["aria-label"]
const _hoisted_33 = { class: "tenant-table" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "ID", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_36 = { class: "tenant-actions" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  colspan: "6",
  class: "py-8 text-center text-gray-500"
}
const _hoisted_39 = {
  key: 2,
  class: "mt-5 flex items-center justify-end gap-3"
}
const _hoisted_40 = { class: "text-sm text-gray-600" }

import { onBeforeUnmount, onMounted, reactive, ref } from "vue";
import { useToast } from "vue-toastification";
import { Button } from "@/components/common";
import StatusLabel from "@/components/common/StatusLabel.vue";
import TenantDataService, {
  TenantProvisionRequest,
  TenantSummary,
  TenantUpdateRequest,
} from "@/services/platform/TenantDataService";
import {
  synchronizeRememberedTenantBranding,
} from "@/services/auth/RememberedAccountService";
import { t } from "@/i18n";

interface RequestError {
  response?: { data?: { message?: string } };
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const toast = useToast();
const tenants = ref<TenantSummary[]>([]);
const loading = ref(false);
const saving = ref(false);
const updating = ref(false);
const showForm = ref(false);
const editingTenant = ref<TenantSummary | null>(null);
const changingTenantId = ref<string | null>(null);
const selectedLogo = ref<File | null>(null);
const logoPreviewUrl = ref("");
const logoInput = ref<HTMLInputElement | null>(null);
const uploadingLogo = ref(false);
const deletingLogo = ref(false);
const page = ref(0);
const totalPages = ref(0);
const allowedLogoTypes = new Set(["image/png", "image/jpeg", "image/webp"]);

const emptyForm = (): TenantProvisionRequest => ({
  name: "",
  bin: "",
  administrator: {
    login: "",
    email: "",
    password: "",
    iin: "",
    name: "",
    middleName: "",
    surname: "",
  },
});

const form = reactive<TenantProvisionRequest>(emptyForm());
const editForm = reactive<TenantUpdateRequest>({ name: "", bin: "" });

function toggleCreateForm() {
  editingTenant.value = null;
  showForm.value = !showForm.value;
}

function startEdit(tenant: TenantSummary) {
  showForm.value = false;
  editingTenant.value = tenant;
  editForm.name = tenant.name;
  editForm.bin = tenant.bin;
  resetLogoEditor();
  if (tenant.logoFileGuid) {
    void loadLogo(tenant);
  }
}

function cancelEdit() {
  resetLogoEditor();
  editingTenant.value = null;
}

function selectLogo(event: Event) {
  const file = (event.target as HTMLInputElement).files?.[0] || null;
  if (!file) {
    selectedLogo.value = null;
    return;
  }
  if (!allowedLogoTypes.has(file.type) || file.size > 1024 * 1024) {
    toast.error(t("tenantManagement.logoInvalid"));
    if (logoInput.value) {
      logoInput.value.value = "";
    }
    selectedLogo.value = null;
    return;
  }
  selectedLogo.value = file;
  setLogoPreview(URL.createObjectURL(file));
}

async function loadLogo(
  tenant: TenantSummary,
  synchronizeCards = false
): Promise<void> {
  try {
    const response = await TenantDataService.getLogo(tenant.id);
    const logo = response.data;
    if (!allowedLogoTypes.has(logo.type)) {
      throw new Error("Unsupported tenant logo type");
    }
    const previewUrl = URL.createObjectURL(logo);
    if (editingTenant.value?.id === tenant.id) {
      setLogoPreview(previewUrl);
    } else {
      URL.revokeObjectURL(previewUrl);
    }
    if (synchronizeCards) {
      await synchronizeRememberedTenantBranding(
        tenant.id,
        tenant.name,
        tenant.logoFileGuid || null,
        await blobToDataUrl(logo)
      );
    }
  } catch {
    if (editingTenant.value?.id === tenant.id) {
      setLogoPreview("");
    }
    if (synchronizeCards) {
      await synchronizeRememberedTenantBranding(
        tenant.id,
        tenant.name,
        tenant.logoFileGuid || null,
        null
      );
    }
  }
}

async function uploadLogo() {
  if (!editingTenant.value || !selectedLogo.value) {
    return;
  }
  const tenant = editingTenant.value;
  const logo = selectedLogo.value;
  uploadingLogo.value = true;
  try {
    const response = await TenantDataService.uploadLogo(tenant.id, logo);
    Object.assign(tenant, response.data?.data || {});
    if (editingTenant.value?.id === tenant.id) {
      selectedLogo.value = null;
      if (logoInput.value) {
        logoInput.value.value = "";
      }
    }
    await loadLogo(tenant, true);
    toast.success(t("tenantManagement.logoUpdated"));
  } catch (error) {
    toast.error(errorMessage(error, t("tenantManagement.logoUpdateError")));
  } finally {
    uploadingLogo.value = false;
  }
}

async function deleteLogo() {
  if (
    !editingTenant.value ||
    !window.confirm(t("tenantManagement.deleteLogoConfirm"))
  ) {
    return;
  }
  const tenant = editingTenant.value;
  deletingLogo.value = true;
  try {
    const response = await TenantDataService.deleteLogo(tenant.id);
    Object.assign(tenant, response.data?.data || {});
    await synchronizeRememberedTenantBranding(
      tenant.id,
      tenant.name,
      null,
      null
    );
    if (editingTenant.value?.id === tenant.id) {
      resetLogoEditor();
    }
    toast.success(t("tenantManagement.logoDeleted"));
  } catch (error) {
    toast.error(errorMessage(error, t("tenantManagement.logoDeleteError")));
  } finally {
    deletingLogo.value = false;
  }
}

function setLogoPreview(url: string) {
  if (logoPreviewUrl.value.startsWith("blob:")) {
    URL.revokeObjectURL(logoPreviewUrl.value);
  }
  logoPreviewUrl.value = url;
}

function resetLogoEditor() {
  setLogoPreview("");
  selectedLogo.value = null;
  if (logoInput.value) {
    logoInput.value.value = "";
  }
}

function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () =>
      typeof reader.result === "string"
        ? resolve(reader.result)
        : reject(new Error("Tenant logo could not be read"));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

function tenantInitials(name: string): string {
  return name
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

async function loadTenants() {
  loading.value = true;
  try {
    const response = await TenantDataService.getAll(page.value);
    tenants.value = response.data?.data?.content || [];
    totalPages.value = response.data?.data?.totalPages || 0;
  } catch (error) {
    toast.error(errorMessage(error, t("tenantManagement.loadError")));
  } finally {
    loading.value = false;
  }
}

async function changePage(nextPage: number) {
  page.value = nextPage;
  await loadTenants();
}

async function provision() {
  saving.value = true;
  try {
    const response = await TenantDataService.provision(form);
    toast.success(
      response.data?.message || t("tenantManagement.createSuccess")
    );
    Object.assign(form, emptyForm());
    showForm.value = false;
    page.value = 0;
    await loadTenants();
  } catch (error) {
    toast.error(errorMessage(error, t("tenantManagement.createError")));
  } finally {
    saving.value = false;
  }
}

async function updateTenant() {
  if (!editingTenant.value) {
    return;
  }
  const tenant = editingTenant.value;
  updating.value = true;
  try {
    const response = await TenantDataService.update(tenant.id, editForm);
    const updated = response.data?.data;
    if (updated) {
      Object.assign(tenant, updated);
    }
    await synchronizeRememberedTenantBranding(
      tenant.id,
      tenant.name,
      tenant.logoFileGuid || null
    );
    if (editingTenant.value?.id === tenant.id) {
      editingTenant.value = null;
    }
    toast.success(t("tenantManagement.updateSuccess"));
  } catch (error) {
    toast.error(errorMessage(error, t("tenantManagement.updateError")));
  } finally {
    updating.value = false;
  }
}

async function toggleStatus(tenant: TenantSummary) {
  if (
    tenant.status === "ACTIVE" &&
    !window.confirm(t("tenantManagement.disableConfirm"))
  ) {
    return;
  }
  changingTenantId.value = tenant.id;
  try {
    const status = tenant.status === "ACTIVE" ? "DISABLED" : "ACTIVE";
    await TenantDataService.updateStatus(tenant.id, status);
    tenant.status = status;
    toast.success(t("tenantManagement.statusSuccess"));
  } catch (error) {
    toast.error(errorMessage(error, t("tenantManagement.statusError")));
  } finally {
    changingTenantId.value = null;
  }
}

function errorMessage(error: unknown, fallback: string): string {
  return (error as RequestError).response?.data?.message || fallback;
}

onMounted(loadTenants);
onBeforeUnmount(resetLogoEditor);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(t)("tenantManagement.title")), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("tenantManagement.description")), 1)
        ]),
        _createVNode(_unref(Button), { onClick: toggleCreateForm }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(showForm.value ? _unref(t)("common.cancel") : _unref(t)("tenantManagement.create")), 1)
          ]),
          _: 1
        })
      ]),
      (showForm.value)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            class: "mt-8 grid grid-cols-1 gap-5 md:grid-cols-2",
            onSubmit: _withModifiers(provision, ["prevent"])
          }, [
            _createElementVNode("label", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("tenantManagement.companyName")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name) = $event)),
                required: "",
                maxlength: "255"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(form).name,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("tenantManagement.bin")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).bin) = $event)),
                required: "",
                maxlength: "40"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(form).bin,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("tenantManagement.adminSurname")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).administrator.surname) = $event)),
                required: "",
                maxlength: "100"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(form).administrator.surname,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_10, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("tenantManagement.adminName")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).administrator.name) = $event)),
                required: "",
                maxlength: "25"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(form).administrator.name,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_11, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("tenantManagement.adminMiddleName")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).administrator.middleName) = $event)),
                maxlength: "100"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(form).administrator.middleName,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_12, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("tenantManagement.iin")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).administrator.iin) = $event)),
                required: "",
                inputmode: "numeric",
                pattern: "[0-9]{12}",
                maxlength: "12"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(form).administrator.iin,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_13, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("tenantManagement.login")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).administrator.login) = $event)),
                required: "",
                maxlength: "100",
                autocomplete: "off"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(form).administrator.login,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_14, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("tenantManagement.email")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).administrator.email) = $event)),
                required: "",
                type: "email",
                maxlength: "100"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(form).administrator.email,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_15, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("tenantManagement.password")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).administrator.password) = $event)),
                required: "",
                type: "password",
                minlength: "8",
                maxlength: "120",
                autocomplete: "new-password"
              }, null, 512), [
                [_vModelText, _unref(form).administrator.password]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_unref(Button), {
                type: "submit",
                disabled: saving.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(saving.value ? _unref(t)("common.loading") : _unref(t)("common.create")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ], 40, _hoisted_6))
        : _createCommentVNode("", true),
      (editingTenant.value)
        ? (_openBlock(), _createElementBlock("form", {
            key: 1,
            class: "mt-8 grid grid-cols-1 gap-5 md:grid-cols-2",
            onSubmit: _withModifiers(updateTenant, ["prevent"])
          }, [
            _createElementVNode("h2", _hoisted_18, _toDisplayString(_unref(t)("tenantManagement.editTitle")), 1),
            _createElementVNode("label", _hoisted_19, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("tenantManagement.companyName")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(editForm).name) = $event)),
                required: "",
                maxlength: "255"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(editForm).name,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_20, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("tenantManagement.bin")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(editForm).bin) = $event)),
                required: "",
                maxlength: "40"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(editForm).bin,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("tenantManagement.logo")), 1),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  (logoPreviewUrl.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: logoPreviewUrl.value,
                        alt: ""
                      }, null, 8, _hoisted_24))
                    : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(tenantInitials(editingTenant.value.name)), 1))
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("input", {
                    ref: (_value, _refs) => {
                      _refs['logoInput'] = _value
                      logoInput.value = _value
                    },
                    type: "file",
                    accept: "image/png,image/jpeg,image/webp",
                    onChange: selectLogo
                  }, null, 544),
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(t)("tenantManagement.logoHelp")), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_unref(Button), {
                      type: "button",
                      disabled: !selectedLogo.value || uploadingLogo.value,
                      onClick: uploadLogo
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(uploadingLogo.value
                      ? _unref(t)("common.loading")
                      : _unref(t)("tenantManagement.uploadLogo")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    (editingTenant.value.logoFileGuid)
                      ? (_openBlock(), _createBlock(_unref(Button), {
                          key: 0,
                          type: "button",
                          variant: "danger",
                          disabled: deletingLogo.value,
                          onClick: deleteLogo
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("tenantManagement.deleteLogo")), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_unref(Button), {
                type: "button",
                variant: "default",
                onClick: cancelEdit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("common.cancel")), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                type: "submit",
                disabled: updating.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(updating.value ? _unref(t)("common.loading") : _unref(t)("common.save")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ], 40, _hoisted_17))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_30, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(t)("common.loading")), 1))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "table-scroll",
            style: {"--table-min-width":"1040px"},
            tabindex: "0",
            role: "region",
            "aria-label": _ctx.$t('common.scrollableTable')
          }, [
            _createElementVNode("table", _hoisted_33, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_34,
                  _createElementVNode("th", null, _toDisplayString(_unref(t)("tenantManagement.companyName")), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(t)("tenantManagement.bin")), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(t)("common.status")), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(t)("tenantManagement.rootCompany")), 1),
                  _hoisted_35
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenants.value, (tenant) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: tenant.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(tenant.id), 1),
                    _createElementVNode("td", null, _toDisplayString(tenant.name), 1),
                    _createElementVNode("td", null, _toDisplayString(tenant.bin), 1),
                    _createElementVNode("td", null, [
                      _createVNode(StatusLabel, {
                        label: tenant.status
                      }, null, 8, ["label"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(tenant.rootCompanyId), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_unref(Button), {
                          variant: "default",
                          onClick: ($event: any) => (startEdit(tenant))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("common.edit")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_unref(Button), {
                          variant: tenant.status === 'ACTIVE' ? 'danger' : 'primary',
                          disabled: changingTenantId.value === tenant.id,
                          onClick: ($event: any) => (toggleStatus(tenant))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tenant.status === "ACTIVE"
                        ? _unref(t)("tenantManagement.disable")
                        : _unref(t)("tenantManagement.activate")), 1)
                          ]),
                          _: 2
                        }, 1032, ["variant", "disabled", "onClick"])
                      ])
                    ])
                  ]))
                }), 128)),
                (tenants.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                      _createElementVNode("td", _hoisted_38, _toDisplayString(_unref(t)("common.noData")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 8, _hoisted_32)),
      (totalPages.value > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createVNode(_unref(Button), {
              variant: "default",
              disabled: page.value === 0 || loading.value,
              onClick: _cache[11] || (_cache[11] = ($event: any) => (changePage(page.value - 1)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("common.back")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createElementVNode("span", _hoisted_40, _toDisplayString(page.value + 1) + " / " + _toDisplayString(totalPages.value), 1),
            _createVNode(_unref(Button), {
              variant: "default",
              disabled: page.value + 1 >= totalPages.value || loading.value,
              onClick: _cache[12] || (_cache[12] = ($event: any) => (changePage(page.value + 1)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("common.next")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})